import axiosClient from '@/api/axios'
import { CategoryModel } from '@/models/CategoryModel'
import { ref } from 'vue'

export function useCategory() {
    const categories = ref<CategoryModel[]>([])
    const isLoading = ref(false)
    const error = ref<string | null>(null)

    const listCategories = async (params: { page?: number; perPage?: number } = {}) => {
        isLoading.value = true
        error.value = null
        try {
            const response = await axiosClient.get(`/customer/categories`, { params })
            categories.value = response.data.data
            return response.data
        } catch (err: any) {
            error.value = err.message || 'Erro ao carregar categorias'
            console.error(err)
            throw err
        } finally {
            isLoading.value = false
        }
    }

    return {
        categories,
        isLoading,
        error,
        listCategories
    }
}
